import { ApplicationApiTagTypes, ApplicationApiUrls } from "@/modules/application/common/enum";
import type {
  ICardServiceInstructionApplication,
  ICreateCardServiceInstructionApplicationRequest,
  IUpdateCardServiceInstructionApplicationRequest,
} from "@/modules/application/common/types";
import { withIdempotency } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const cardServiceInstructionApplicationApi = createApi({
  reducerPath: "cardServiceInstructionApplicationApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: [ApplicationApiTagTypes.ApplicationHistory],
  endpoints: (builder) => ({
    createCardServiceInstructionApplication: builder.mutation<string, ICreateCardServiceInstructionApplicationRequest>(
      withIdempotency<ICreateCardServiceInstructionApplicationRequest>(
        ApplicationApiUrls.CardServiceInstructionApplication,
      )),
    updateCardServiceInstructionApplication: builder.mutation<string, IUpdateCardServiceInstructionApplicationRequest>(
      {
        query: ({ data, id }) => ({
          url: `${ApplicationApiUrls.CardServiceInstructionApplication}/${id}`,
          method: "PUT",
          data,
        }),
      }),
    getCardServiceInstructionApplication: builder.query<ICardServiceInstructionApplication, {
      id: string
    }>({
      query: ({ id }) => ({
        url: `${ApplicationApiUrls.CardServiceInstructionApplication}/${id}`,
      }),
    }),
  }),
});

export const {
  useGetCardServiceInstructionApplicationQuery,
  useCreateCardServiceInstructionApplicationMutation,
  useUpdateCardServiceInstructionApplicationMutation,
} = cardServiceInstructionApplicationApi;
